// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"ce7df5fb","702":"90fbe4c0","703":"127aa73e","975":"263e83ca"}[chunkId] + ".chunk.js";
};